jQuery('body').on('click', '.link-vin-detail', function(e) {
    e.preventDefault();

    var post_id = jQuery(this).attr('data-id');

    jQuery('.ocean[data-id="' + post_id + '"]').addClass("active");

    jQuery('#vin-detail, body').removeClass('vin-detail-open');

    jQuery.post(
        ajaxurl,
        {
            'action': 'vin_detail',
            'id': post_id
        },
        function(response){
            jQuery('#vin-detail, body').addClass('vin-detail-open');
            jQuery('#vin-detail').html(response);
        }
    );

});

jQuery('body').on('click', '.bt-recette', function(e) {
    e.preventDefault();
    
    jQuery('.content-vin').addClass('flip');
});

jQuery('body').on('click', '.bt-retour', function(e) {
    e.preventDefault();
    
    jQuery('.content-vin').removeClass('flip');
});

jQuery('body').on('click', '.vin-detail-close', function(e) {
    e.preventDefault();
    
    jQuery('#vin-detail, body').removeClass('vin-detail-open');
    jQuery('#vin-detail').html('');
    jQuery('.ocean').removeClass("active");
});

jQuery(document).mouseup(function(e) {
    e.preventDefault();

    var container = jQuery('.content-vin');

    if (!container.is(e.target) && container.has(e.target).length === 0) {
        jQuery('#vin-detail, body').removeClass('vin-detail-open');
        jQuery('#vin-detail').html('');
        jQuery('.ocean').removeClass("active");
    }
});
